/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 15:55:51
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-19 16:02:04
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/Components/GeneralCollapseHeader/index.tsx
 */
import React from 'react';

import css from './css.module.less';

import { InfoCircleFilled } from '@ant-design/icons';
import Dots from 'src/constrains/DotsMenuDrop';
import { Icon } from '@/src/tools/icon';

const ClickableConfigItem = (props) => {
  const {
    className,
    content,
    err,
    hasDots,
    dotsFunction = [],
    onClick,
    Error,
    isSelected,
  } = props;
  return (
    <div
      className={`${css.container} ${className || ''}`}
      onClick={onClick}
      {...(isSelected ? { style: { backgroundColor: '#ccefd4' } } : {})}>
      <div className={css.content}>{content}</div>
      {Error || (err && <InfoCircleFilled rev className={css.iconWarn} />)}
      {hasDots && (
        <div className={css.dots}>
          <Dots options={dotsFunction} />
        </div>
      )}
      <Icon type='iconback' className={css.icon} />
    </div>
  );
};
export default ClickableConfigItem;
